import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background-color: ", ";\n  bottom: 0;\n  box-sizing: border-box;\n  display: flex;\n  height: ", "px;\n  justify-content: space-between;\n  padding: 0 10px;\n  position: absolute;\n  transform: translateY(", "px);\n  transition: transform ", ";\n  width: 100%;\n  z-index: 1;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { Transition } from 'react-transition-group';
import { color, property } from '@scp/ui-shared/theme/variables';
import { Button } from '@scp/ui-shared/components/buttons';
export var ACTIONBAR_HEIGHT = 50;
var TEXT = {
  Cancel: 'Cancel',
  Submit: 'Submit'
};
var Footer = styled.footer(_templateObject(), color.action, ACTIONBAR_HEIGHT, function (props) {
  return props.visible ? 0 : ACTIONBAR_HEIGHT;
}, property.transition);
/**
 * @example ./__docs__/ActionBar.md
 */

export function ActionBar(_ref) {
  var visible = _ref.visible,
      onCancel = _ref.onCancel,
      onSubmit = _ref.onSubmit,
      _ref$cancelText = _ref.cancelText,
      cancelText = _ref$cancelText === void 0 ? TEXT.Cancel : _ref$cancelText,
      _ref$submitText = _ref.submitText,
      submitText = _ref$submitText === void 0 ? TEXT.Submit : _ref$submitText;
  var transitionRef = React.useRef(null);
  return React.createElement(Transition, {
    in: visible,
    timeout: property.transitionDuration,
    nodeRef: transitionRef,
    mountOnEnter: true,
    unmountOnExit: true
  }, function (state) {
    return React.createElement(Footer, {
      visible: state === 'entered'
    }, onCancel && React.createElement(Button, {
      onClick: onCancel
    }, cancelText), onSubmit && React.createElement(Button, {
      reversed: true,
      iconName: "arrow-forward",
      onClick: onSubmit
    }, submitText));
  });
}